
import styled from "styled-components"
import firmaLogoLight from "../../../../images/svg/topYogunluk/egeyurt-light.svg"
import firmaLogoDark from "../../../../images/svg/topYogunluk/egeyurt-dark.svg"
import TopbarUser from "./TopbarTopUser"
import { useSelector } from "react-redux"
import TopbarGaraj from "./TopbarGaraj"
import { handleGarageStats } from "../../../../features/layout/layoutSlice"
import { useDispatch } from "react-redux"
import { TfiArrowCircleDown } from "react-icons/tfi";


const Container = styled.div`
  width: 100%;
  height: ${({isOpen}) => isOpen ? "100px" : "70px"};
  border-bottom: 1px solid ${({ theme }) => theme.mainBorderColor};
  z-index: 20;
  color: ${({theme}) => theme.mainTextColor};

  .wrapper-open{
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding-right: 10px;

    .garage-title{
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-xl);
      margin-left: 30px;
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;

      .arr-icon{
        fill: var(--color-main);
        font-size: 1.1rem;
        transform: ${({isOpen}) => !isOpen ? `rotate(270deg)` : "rotate(0)"};
      }
    }

    .garage-container{
      margin: 0 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      .logo{
        width: 140px;
        margin-right: 15px;
      }
    }
  }

  .wrapper-close-shipper{
        display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding-right: 30px;
  }

  .wrapper-close{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;

    .garage-title{
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-xl);
      margin-left: 30px;
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
    }

    .user-side{
      display: flex;
      align-items: center;
      gap: 15px;
      padding-right: 15px;
    }

    .arr-icon{
      fill: var(--color-main);
      font-size: 1.1rem;
      transform: ${({isOpen}) => !isOpen ? `rotate(270deg)` : "rotate(0)"};
    }
  }
`

const TopbarTop = () => {

  const {theme, garageStatsState} = useSelector((state)=> state.layout)
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const rld = JSON.parse(storage.getItem("rld"))
  const dispatch = useDispatch()
  if(rld === "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" || rld === "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228"){
    return (
          <Container isOpen={false}>
            <div className="wrapper-close-shipper">
              <div/>
              <TopbarUser/>
            </div>
          </Container>
    )
  }

  
  return (
    <Container isOpen={garageStatsState === "open"}>
      {
        garageStatsState === "open" ?
        <div className="wrapper-open">
          <div></div>
          <div className="garage-container" style={{display: "flex", justifyContent: "flex-end"}}>
            {/* <TopbarGaraj/> */}
            <TopbarUser/>
          </div>
        </div>
        :
        <div className="wrapper-close">
          {/* <div className="garage-title" onClick={() => dispatch(handleGarageStats(garageStatsState === "open" ? "close" : "open"))}><TfiArrowCircleDown className="arr-icon"/> Kamyon Garajı Yoğunluk Bilgisi</div> */}
          <div className="user-side">
              <TopbarUser/>
            </div>
        </div>
        }
    </Container>
  )
}

export default TopbarTop